(function () {
  'use strict';
  var IK = window.PETIDI_IKON || {};   // 1 Kas 2026: emoji yerine temanın ikon seti
  // "Hangi Mama?" quiz'i — çekmece içinde 7 soru + öneri.
  // Ürün verisi: /collections/all?view=quiz (Shopify kategori metafield'ları).
  // Cevaplar window.PetidiPetProfile.add ile Pati Profili'ne yazılır.

  // Çeviri (theme.liquid window.PETIDI_T; Türkçede boş → varsayılan) + dil öneki (PETIDI_KOK)
  var T = window.PETIDI_T || {};
  // Kilo sınırı — pet-profile.js kiloHata ile aynı (kedi 15, köpek 100 kg; gramla yazılanı engeller)
  function kiloHataQz(v, tur) {
    var s = String(v == null ? '' : v).trim().replace(',', '.');
    if (!s) return '';
    var n = parseFloat(s), mx = tur === 'kedi' ? 15 : 100;
    if (isFinite(n) && n > 0 && n <= mx) return '';
    return tt('kilo_hata', 'Kiloyu kg olarak yaz (ör. 1,5). En fazla [max] kg olabilir.', { max: mx });
  }
  function tt(k, d, o) { var s = T[k] || d; if (o) Object.keys(o).forEach(function (x) { s = s.split('[' + x + ']').join(o[x]); }); return s; }
  function tn(k, n, d, o) { o = o || {}; o.n = n; return tt(k + (n === 1 ? '.one' : '.other'), d, o); }
  var SRC = (window.PETIDI_KOK || '') + '/collections/all?view=quiz';
  // Varsayılan olmayan dil (/en): ürün adları çevrilmiş gelir → adlara bakan kurallar İngilizce kelimeleri de tanır.
  // Türkçede (PETIDI_KOK boş) kurallar birebir eskisi gibi.
  var YABANCI = !!window.PETIDI_KOK;
  var MAX_PAGES = 8; // güvenlik sınırı (8 x 100 ürün; şablon 100lük — 5 Kas 2026, 50likte 11 sayfaydı, son 3 okunmuyordu)
  var TOTAL = 7;
  var QLS = 'petidi_quiz_cevaplar'; // tamamlanan testin cevapları — sonuçlara geri dönüş için

  var root = document.getElementById('PetQuiz');
  if (!root) return;
  var body = root.querySelector('[data-qz-body]');
  var bar = root.querySelector('[data-qz-bar]');

  // Son alımlar (pet-profile.liquid köprüsü) — "daha önce almıştın" rozeti için
  var PURCHASES = [];
  try {
    var prEl = document.getElementById('PetReorderData');
    if (prEl) PURCHASES = JSON.parse(prEl.textContent).alimlar || [];
  } catch (e0) {}

  function handleOf(u) {
    var m = /\/products\/([^\/?#]+)/.exec(String(u || ''));
    return m ? m[1] : '';
  }
  function boughtBefore(u) {
    var h = handleOf(u);
    if (!h) return false;
    for (var i = 0; i < PURCHASES.length; i++) {
      if (PURCHASES[i].h && PURCHASES[i].h === h) return true;
    }
    return false;
  }

  var A = {};       // cevaplar
  var step = 0;     // 0 giriş, 1..7 soru, 8 hesap, 9 sonuç
  var saved = false;
  var showAll = false;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // Türkçe karakterleri sadeleştirip küçük harfe indirger — etiket/başlık eşleştirme için
  function norm(s) {
    var map = { 'ı': 'i', 'İ': 'i', 'ş': 's', 'Ş': 's', 'ğ': 'g', 'Ğ': 'g', 'ü': 'u', 'Ü': 'u', 'ö': 'o', 'Ö': 'o', 'ç': 'c', 'Ç': 'c' };
    return String(s == null ? '' : s).replace(/[ıİşŞğĞüÜöÖçÇ]/g, function (c) { return map[c]; }).toLowerCase();
  }
  function hasAny(arr, keys) {
    for (var i = 0; i < arr.length; i++) {
      var n = norm(arr[i]);
      for (var j = 0; j < keys.length; j++) if (n.indexOf(keys[j]) >= 0) return true;
    }
    return false;
  }
  function tl(cents) {
    var v = cents / 100;
    return v.toLocaleString('tr-TR', { minimumFractionDigits: v % 1 ? 2 : 0, maximumFractionDigits: v % 1 ? 2 : 0 }) + ' TL';
  }

  /* ---------------- Katalog ---------------- */
  var catalog = null;
  var catalogPromise = null;
  function loadCatalog() {
    if (catalogPromise) return catalogPromise;
    catalogPromise = fetch(SRC + '&page=1')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var d = JSON.parse(t);
        var pages = Math.min(d.pages || 1, MAX_PAGES);
        var rest = [];
        for (var i = 2; i <= pages; i++) {
          rest.push(fetch(SRC + '&page=' + i)
            .then(function (r) { return r.text(); })
            .then(function (t2) { return JSON.parse(t2).products || []; })
            .catch(function () { return []; }));
        }
        return Promise.all(rest).then(function (chunks) {
          catalog = (d.products || []).concat.apply(d.products || [], chunks);
          return catalog;
        });
      })
      .catch(function () { catalog = []; return catalog; });
    return catalogPromise;
  }

  /* ---------------- Porsiyon (pet-profile.js eğrisiyle aynı) ---------------- */
  function dailyGrams() {
    var kg = A.kilo || (A.tur === 'kedi' ? 4 : 20);
    var base = (A.tur === 'kedi' ? 18 : 26.5) * Math.pow(kg, 0.75);
    if (A.yas === 'yavru') base *= 1.5;
    else if (A.yas === 'senior') base *= 0.9;
    if (A.kisir) base *= 0.9;
    return base;
  }

  function dogumFromYas() {
    var d = new Date();
    var backAy = A.yas === 'yavru' ? 4 : (A.yas === 'senior' ? (A.tur === 'kedi' ? 156 : 120) : 48);
    var total = d.getFullYear() * 12 + d.getMonth() - backAy;
    return Math.floor(total / 12) + '-' + ('0' + (total % 12 + 1)).slice(-2);
  }

  /* ---------------- Öneri motoru ---------------- */
  var ALG = {
    tavuk: ['tavuk', 'chicken'],
    sigir: ['sigir', 'dana', 'beef', 'veal', 'biftek'],
    balik: ['balik', 'somon', 'salmon', 'ton', 'tuna', 'fish', 'seafood', 'deniz', 'hamsi', 'alabalik'],
    laktoz: ['peynir', 'cheese', 'sut', 'milk', 'laktoz']
  };
  var YAVRU_K = ['yavru', 'kitten', 'puppy', 'junior'];
  var SENIOR_K = ['senior', 'kidemli', 'yasli', 'mature', '+7', '7+', '+10', '10+'];
  var TAHILSIZ_K = ['tahilsiz', 'grain'];

  function analyse(p) {
    var t = norm(p.t);
    var isYavru = hasAny(p.age, YAVRU_K) || hasAny([t], YAVRU_K);
    var isAdultTagged = hasAny(p.age, ['yetiskin', 'adult']);
    var isSenior = hasAny(p.age, SENIOR_K) || hasAny([t], SENIOR_K);
    var isKuru = p.form.length
      ? hasAny(p.form, ['kuru', 'dry'])
      : YABANCI
        ? (/food|treat/.test(t) && !/wet|canned|pouch|treat|soup|broth/.test(t))
        : (t.indexOf('mama') >= 0 && !/yas mama|konserve|pouch|odul|corba/.test(t));
    var tahilsiz = hasAny(p.diet, TAHILSIZ_K) || t.indexOf('tahilsiz') >= 0 || (YABANCI && t.indexOf('grain-free') >= 0);
    // Kısır formülü: taksonomide alan yok — "Kilo kontrolü + İdrar sağlığı" birlikteyse
    // ya da başlık söylüyorsa kısır formülü sayarız.
    var kisirF = (hasAny(p.diet, ['kilo', 'weight']) && hasAny(p.diet, ['idrar', 'urinar'])) ||
      /kisir|sterili|neutered/.test(t);
    return { t: t, isYavru: isYavru, isAdultTagged: isAdultTagged, isSenior: isSenior, isKuru: isKuru, tahilsiz: tahilsiz, kisirF: kisirF };
  }

  function breedBucketKeys(a) {
    if (a.tur !== 'kopek' || !a.kilo) return null;
    if (a.kilo < 10) return ['kucuk', 'small', 'mini'];
    if (a.kilo <= 25) return ['orta', 'medium'];
    return ['buyuk', 'large', 'maxi', 'iri'];
  }

  // Sert filtreler — quiz önerileri VE koleksiyondaki "önerilen" çerçevesi
  // aynı kuralları kullanır. a: cevaplar, p: ürün verisi, x: analyse(p) çıktısı.
  function passesFilters(a, p, x) {
    if (!x.isKuru) return false;

    // Yaş uyumu
    if (a.yas === 'yavru' && !x.isYavru) return false;
    if (a.yas !== 'yavru' && x.isYavru && !x.isAdultTagged) return false;

    // Alerji: protein hassasiyetinde tat verisi olmayan ürünü güvenli tarafta ele
    var alerji = a.alerji || [];
    var proteinAlerji = alerji.filter(function (al) { return al !== 'tahil' && al !== 'laktoz'; });
    var PROTEIN_K = ['somon', 'tavuk', 'kuzu', 'dana', 'sigir', 'balik', 'ton', 'hindi', 'ordek'];
    if (YABANCI) PROTEIN_K = PROTEIN_K.concat(['salmon', 'chicken', 'lamb', 'beef', 'fish', 'tuna', 'turkey', 'duck']);
    if (proteinAlerji.length && !p.flavor.length && !hasAny([x.t], PROTEIN_K)) return false;
    for (var i = 0; i < proteinAlerji.length; i++) {
      var keys = ALG[proteinAlerji[i]];
      if (hasAny(p.flavor, keys) || hasAny([x.t], keys)) return false;
    }
    if (alerji.indexOf('laktoz') >= 0 && (hasAny(p.flavor, ALG.laktoz) || hasAny([x.t], ALG.laktoz))) return false;
    if (alerji.indexOf('tahil') >= 0 && !x.tahilsiz) return false;

    // Irk boyu (köpek): ürün boy belirtmişse ve kovamıza uymuyorsa ele
    var bucket = breedBucketKeys(a);
    if (bucket && p.breed.length && !hasAny(p.breed, bucket)) return false;
    return true;
  }

  function recommend() {
    var daily = dailyGrams();
    var bucket = breedBucketKeys(A);
    var out = [];

    (catalog || []).forEach(function (p) {
      if (p.sp !== A.tur) return;
      var x = analyse(p);
      if (!passesFilters(A, p, x)) return;

      // Paket önerisi: 100 güne kadar bitenler içinde kg fiyatı en düşük olan.
      // Stoktaki varyantlar öncelikli; hepsi ön siparişse onlardan seçilir.
      var vars = [];
      var stok = 0;
      var untracked = false;
      p.v.forEach(function (v) {
        if (v.a !== 1) return;
        if (v.inv === -1) untracked = true;
        else if (v.inv > 0) stok += v.inv;
        if (v.kg > 0 && v.f > 0) {
          vars.push({ id: v.id, kg: v.kg, f: v.f, unit: v.f / v.kg, gun: Math.round(v.kg * 1000 / daily), po: v.po === 1 });
        }
      });
      if (!vars.length) return;
      var stokta = vars.filter(function (v) { return !v.po; });
      var havuz = stokta.length ? stokta : vars;
      var uygun = havuz.filter(function (v) { return v.gun <= 100; });
      var pick = (uygun.length ? uygun : havuz).reduce(function (a, b) {
        if (uygun.length) return b.unit < a.unit ? b : a;
        return b.gun < a.gun ? b : a;
      });
      // Stok takipsiz varyant = her zaman satılabilir kabul et
      if (untracked) stok = Math.max(stok, 100000);
      var preorderOnly = !stokta.length;

      var s = 0;
      if (A.yas === 'yavru' && x.isYavru) s += 2;
      if (A.yas === 'senior' && x.isSenior) s += 3;
      if (A.yas === 'yetiskin' && !x.isSenior) s += 1;
      if (A.kisir && x.kisirF) s += 2;
      if (x.tahilsiz) s += 1;
      if (bucket && hasAny(p.breed, bucket)) s += 1;

      out.push({ p: p, x: x, pick: pick, score: s, stok: stok, preorderOnly: preorderOnly });
    });

    // Sıralama: stoğu 0 olup ön siparişi açık olanlar en alta; kalanlar stok
    // çoktan aza; eşitlikte uygunluk puanı, sonra bütçe tercihi (kg fiyatı).
    out.sort(function (a, b) {
      if (a.preorderOnly !== b.preorderOnly) return a.preorderOnly ? 1 : -1;
      if (b.stok !== a.stok) return b.stok - a.stok;
      if (b.score !== a.score) return b.score - a.score;
      if (A.butce === 'premium') return b.pick.unit - a.pick.unit;
      return a.pick.unit - b.pick.unit;
    });
    return out;
  }

  /* ---------------- Koleksiyonda "önerilen ürün" çerçevesi ---------------- */
  // card-product.liquid her mama kartına data-pet-match (kategori metafield
  // verisi) basar; burada profile göre değerlendirip çerçeve + etiket ekleriz.
  function YAS_AD() { return { yavru: tt('qz_yavru', 'yavru'), yetiskin: tt('qz_yetiskin', 'yetişkin'), senior: tt('qz_kidemli', 'kıdemli') }; }
  function setReco(card, on, label) {
    card.classList.toggle('pcard--reco', on);
    var tag = card.querySelector('.pcard__reco');
    if (on) {
      if (!tag) {
        tag = document.createElement('span');
        tag.className = 'pcard__reco';
        card.insertBefore(tag, card.firstChild);
      }
      tag.textContent = label;
    } else if (tag) {
      tag.parentNode.removeChild(tag);
    }
  }

  function renderRecoCards() {
    var nodes = document.querySelectorAll('[data-pet-match]');
    var noteEl = document.querySelector('[data-pet-collnote]');
    if (!nodes.length) { if (noteEl) noteEl.hidden = true; return; }

    var list = petList();
    var groups = {};
    Array.prototype.forEach.call(nodes, function (card) {
      var d = null;
      try { d = JSON.parse(card.getAttribute('data-pet-match')); } catch (e) {}
      if (!d || !d.sp) { setReco(card, false, ''); return; }
      var pet = null;
      for (var i = 0; i < list.length; i++) {
        if (list[i].tur === d.sp) { pet = list[i]; break; }
      }
      if (!pet) { setReco(card, false, ''); return; }
      var g = groups[d.sp];
      if (!g) g = groups[d.sp] = { pet: pet, a: answersFromPet(pet), items: [] };
      var tEl = card.querySelector('.pcard__title');
      var p = { t: (tEl ? tEl.textContent : ''), age: d.age || [], form: d.form || [], flavor: d.flavor || [], diet: d.diet || [], breed: d.breed || [] };
      var x = analyse(p);
      g.items.push({ card: card, ok: passesFilters(g.a, p, x), kisirF: x.kisirF, senior: x.isSenior });
    });

    var noteData = null;
    Object.keys(groups).forEach(function (sp) {
      var g = groups[sp];
      var okItems = g.items.filter(function (it) { return it.ok; });
      // Uyarlanabilir seçicilik: kısır pette kısır formüller, kıdemli pette
      // senior formüller de varsa çerçeveyi onlara daralt (vitrin etkisi kalsın)
      if (g.a.kisir) {
        var kf = okItems.filter(function (it) { return it.kisirF; });
        if (kf.length) okItems = kf;
      }
      if (g.a.yas === 'senior') {
        var sf = okItems.filter(function (it) { return it.senior; });
        if (sf.length) okItems = sf;
      }
      var label = tt('qz_onerilen', '[ad] için önerilen', { ad: g.pet.ad });
      g.items.forEach(function (it) {
        setReco(it.card, okItems.indexOf(it) >= 0, label);
      });
      if (okItems.length && !noteData) noteData = g;
    });

    if (noteEl) {
      // "Tekrar Al" şeridi görünürse aynı sayfada ikinci şerit binmesin
      if (document.querySelector('[data-pet-reorder]:not([hidden])')) noteData = null;
      if (noteData) {
        var a2 = noteData.a;
        var parts = [];
        if (a2.kisir) parts.push(tt('qz_kisir', 'kısır'));
        parts.push(YAS_AD()[a2.yas]);
        if (a2.kilo) parts.push(String(a2.kilo).replace('.', tt('ondalik', ',')) + ' kg');
        noteEl.innerHTML = (IK.paw || '') + '<span>' + tt('qz_isaretledik', '<strong>[ad]</strong> için uygun mamaları işaretledik — [ozet] profiline göre.', { ad: esc(noteData.pet.ad), ozet: parts.join(', ') }) + '</span>' +
          '<button type="button" data-petp-open data-petp-edit="' + esc(noteData.pet.id) + '">' + tt('qz_profili_duzenle', 'Profili düzenle') + '</button>';
        noteEl.hidden = false;
      } else {
        noteEl.hidden = true;
      }
    }
  }

  var recoTimer = null;
  function scheduleReco() {
    window.clearTimeout(recoTimer);
    recoTimer = window.setTimeout(renderRecoCards, 50);
  }

  /* ---------------- Ekranlar ---------------- */
  function opt(key, val, emoji, label, sub, current) {
    return '<button type="button" class="qz__opt' + (current === val ? ' is-active' : '') + '" data-qz-opt="' + key + ':' + val + '">' +
      (emoji ? '<span class="qz__opt-emoji">' + emoji + '</span>' : '') +
      '<span class="qz__opt-info"><strong>' + label + '</strong>' + (sub ? '<small>' + sub + '</small>' : '') + '</span>' +
      '</button>';
  }

  function meta(showBack) {
    return '<div class="qz__meta">' +
      (showBack ? '<button type="button" class="qz__back" data-qz-back>' + tt('qz_geri', '‹ Geri') + '</button>' : '') +
      (step >= 1 && step <= TOTAL ? '<span class="qz__count">' + tt('qz_soru', 'SORU [n]/[top]', { n: step, top: TOTAL }) + '</span>' : '') +
      '</div>';
  }

  function render() {
    bar.style.width = (step === 0 ? 0 : Math.min(step, TOTAL) / TOTAL * 100) + '%';
    var h = '';

    if (step === 0) {
      h = '<div class="qz__step qz__intro">' +
        '<div class="qz__intro-paw">' + (IK.paw || '') + '</div>' +
        '<h2>' + tt('qz_baslik', 'Hangi mama?') + '</h2>' +
        '<p>' + tt('qz_giris', '7 kısa soruda dostuna en uygun mamayı bulalım.') + '</p>' +
        '<span class="qz__intro-time">' + tt('qz_sure', '~1 dakika sürer') + '</span>' +
        '<ul class="qz__perks">' +
        '<li><span>' + (IK.spark || '') + '</span> ' + tt('qz_perk1', 'Yaşına, kilosuna ve hassasiyetlerine göre öneri') + '</li>' +
        '<li><span>' + (IK.calendar || '') + '</span> ' + tt('qz_perk2', 'Günlük porsiyon + "kaç gün yeter" hesabı') + '</li>' +
        '<li><span>' + (IK.paw || '') + '</span> ' + tt('qz_perk3', 'Cevapların Pati Profili\'ni de oluşturur — hatırlatmalar otomatik açılır') + '</li>' +
        '</ul>' +
        '<button type="button" class="qz__next" data-qz-start>' + tt('qz_basla', 'Başlayalım') + '</button>' +
        '</div>';
    }

    else if (step === 1) {
      h = '<div class="qz__step">' + meta(false) +
        '<h3 class="qz__q">' + tt('qz_kimin', 'Kimin için mama arıyoruz?') + '</h3>' +
        '<p class="qz__sub">' + tt('qz_kimin_alt', 'Önerileri türüne göre şekillendireceğiz.') + '</p>' +
        '<div class="qz__opts qz__opts--row">' +
        opt('tur', 'kedi', IK.cat || '', tt('tur_kedi', 'Kedi'), '', A.tur) +
        opt('tur', 'kopek', IK.dog || '', tt('tur_kopek', 'Köpek'), '', A.tur) +
        '</div></div>';
    }

    else if (step === 2) {
      h = '<div class="qz__step">' + meta(true) +
        '<h3 class="qz__q">' + tt('qz_adi', 'Adı ne?') + '</h3>' +
        '<p class="qz__sub">' + tt('qz_adi_alt', 'Önerileri ona göre kişiselleştireceğiz.') + '</p>' +
        '<input type="text" class="qz__input" data-qz-ad-input maxlength="30" placeholder="' + tt('qz_ad_ph', 'Örn. Boncuk') + '" value="' + esc(A.ad || '') + '" autocomplete="off">' +
        '<button type="button" class="qz__next" data-qz-ad disabled>' + tt('qz_devam', 'Devam') + '</button>' +
        '</div>';
    }

    else if (step === 3) {
      var kedi = A.tur === 'kedi';
      h = '<div class="qz__step">' + meta(true) +
        '<h3 class="qz__q">' + tt('qz_cag', '[ad] hangi çağda?', { ad: esc(A.ad) }) + '</h3>' +
        '<p class="qz__sub">' + tt('qz_cag_alt', 'Porsiyon ve mama tipi yaşa göre değişir.') + '</p>' +
        '<div class="qz__opts">' +
        opt('yas', 'yavru', '', tt('qz_yavru_b', 'Yavru'), tt('qz_0_12', '0–12 ay'), A.yas) +
        opt('yas', 'yetiskin', '', tt('qz_yetiskin_b', 'Yetişkin'), kedi ? tt('qz_1_9', '1–9 yaş') : tt('qz_1_7', '1–7 yaş'), A.yas) +
        opt('yas', 'senior', '', tt('qz_kidemli_b', 'Kıdemli'), kedi ? tt('qz_10_ustu', '10 yaş ve üzeri') : tt('qz_8_ustu', '8 yaş ve üzeri'), A.yas) +
        '</div></div>';
    }

    else if (step === 4) {
      var chips = A.tur === 'kedi'
        ? [['3', tt('qz_k_minyon', 'Minyon · ~3 kg')], ['4', tt('qz_k_ortalama', 'Ortalama · ~4 kg')], ['5.5', tt('qz_k_iri', 'İri · ~5,5 kg')], ['', tt('qz_bilmiyorum', 'Bilmiyorum')]]
        : [['4', tt('qz_d_mini', 'Mini · ~4 kg')], ['8', tt('qz_d_kucuk', 'Küçük · ~8 kg')], ['17', tt('qz_d_orta', 'Orta · ~17 kg')], ['30', tt('qz_d_buyuk', 'Büyük · ~30 kg')], ['', tt('qz_bilmiyorum', 'Bilmiyorum')]];
      h = '<div class="qz__step">' + meta(true) +
        '<h3 class="qz__q">' + tt('qz_kilo', '[ad] kaç kilo?', { ad: esc(A.ad) }) + '</h3>' +
        '<p class="qz__sub">' + tt('qz_kilo_alt', 'Aşağı yukarı da olur — porsiyonu buna göre hesaplayacağız.') + '</p>' +
        '<div class="qz__chips">' +
        chips.map(function (c) {
          var act = (A.kiloChip === c[0]) ? ' is-active' : '';
          return '<button type="button" class="qz__chip' + act + '" data-qz-kilo="' + c[0] + '">' + c[1] + '</button>';
        }).join('') +
        '</div>' +
        '<label class="qz__label" for="QzKilo">' + tt('qz_tam_kilo', 'Tam kilosunu biliyorsan <small>(isteğe bağlı)</small>') + '</label>' +
        '<input type="number" class="qz__input" id="QzKilo" min="0.1" max="100" step="0.1" inputmode="decimal" placeholder="' + tt('qz_kilo_ph', 'Örn. 4,2') + '" value="' + (A.kiloManuel || '') + '">' +
        '<small class="qz__hata" data-qz-kilo-hata role="alert" hidden></small>' +
        '<button type="button" class="qz__next" data-qz-kilonext' + (A.kiloChip !== undefined || A.kiloManuel ? '' : ' disabled') + '>' + tt('qz_devam', 'Devam') + '</button>' +
        '</div>';
    }

    else if (step === 5) {
      h = '<div class="qz__step">' + meta(true) +
        '<h3 class="qz__q">' + tt('qz_kisir_mi', '[ad] kısırlaştırıldı mı?', { ad: esc(A.ad) }) + '</h3>' +
        '<p class="qz__sub">' + tt('qz_kisir_alt', 'Kısır dostların enerji ihtiyacı ~%10 daha az.') + '</p>' +
        '<div class="qz__opts">' +
        opt('kisir', 'evet', '', tt('qz_evet', 'Evet'), '', A.kisirSecim) +
        opt('kisir', 'hayir', '', tt('qz_hayir', 'Hayır'), '', A.kisirSecim) +
        opt('kisir', 'bilmiyorum', '', tt('qz_emin_degil', 'Emin değilim'), '', A.kisirSecim) +
        '</div></div>';
    }

    else if (step === 6) {
      var al = A.alerji || [];
      var chipsA = [['tahil', tt('al_tahil', 'Tahıl')], ['tavuk', tt('al_tavuk', 'Tavuk')], ['sigir', tt('al_sigir', 'Sığır')], ['balik', tt('al_balik', 'Balık')], ['laktoz', tt('al_laktoz', 'Laktoz')]];
      h = '<div class="qz__step">' + meta(true) +
        '<h3 class="qz__q">' + tt('qz_hassasiyet', 'Bilinen bir hassasiyeti var mı?') + '</h3>' +
        '<p class="qz__sub">' + tt('qz_hassasiyet_alt', 'Birden fazla seçebilirsin; uymayan mamaları eleyeceğiz.') + '</p>' +
        '<div class="qz__chips">' +
        chipsA.map(function (c) {
          return '<button type="button" class="qz__chip' + (al.indexOf(c[0]) >= 0 ? ' is-active' : '') + '" data-qz-alerji="' + c[0] + '">' + c[1] + '</button>';
        }).join('') +
        '<button type="button" class="qz__chip' + (A.alerjiYok ? ' is-active' : '') + '" data-qz-alerji-yok>' + tt('qz_yok', 'Yok') + '</button>' +
        '</div>' +
        '<button type="button" class="qz__next" data-qz-alerjinext' + (al.length || A.alerjiYok ? '' : ' disabled') + '>' + tt('qz_devam', 'Devam') + '</button>' +
        '</div>';
    }

    else if (step === 7) {
      h = '<div class="qz__step">' + meta(true) +
        '<h3 class="qz__q">' + tt('qz_butce', 'Bütçe yaklaşımın?') + '</h3>' +
        '<p class="qz__sub">' + tt('qz_butce_alt', 'Önerilerin sırasını buna göre ayarlayacağız.') + '</p>' +
        '<div class="qz__opts">' +
        opt('butce', 'ekonomik', '', tt('qz_ekonomik', 'Ekonomik'), tt('qz_ekonomik_alt', 'Kilogram fiyatı önde olsun'), A.butce) +
        opt('butce', 'dengeli', '', tt('qz_dengeli', 'Dengeli'), tt('qz_dengeli_alt', 'Fiyat ve içerik dengesi'), A.butce) +
        opt('butce', 'premium', '', tt('qz_premium', 'Premium'), tt('qz_premium_alt', 'İçerik kalitesi önde olsun'), A.butce) +
        '</div></div>';
    }

    else if (step === 8) {
      h = '<div class="qz__step qz__calc">' +
        '<span class="qz__calc-paw">' + (IK.paw || '') + '</span>' +
        '<p data-qz-calcmsg>' + tt('qz_hesaplaniyor', 'Porsiyon hesaplanıyor…') + '</p>' +
        '<small>' + tt('qz_taraniyor_ad', '[ad] için en uygun mamalar taranıyor', { ad: esc(A.ad) }) + '</small>' +
        '</div>';
    }

    else if (step === 9) {
      h = renderResult();
    }

    body.innerHTML = h;
    body.scrollTop = 0;

    if (step === 2) {
      var inp = body.querySelector('[data-qz-ad-input]');
      var btn = body.querySelector('[data-qz-ad]');
      var syncAd = function () { btn.disabled = !inp.value.trim(); };
      inp.addEventListener('input', syncAd); syncAd();
      inp.addEventListener('keydown', function (e) { if (e.key === 'Enter' && inp.value.trim()) go(3, { ad: inp.value.trim() }); });
      inp.focus();
    }
    if (step === 4) {
      var kInp = document.getElementById('QzKilo');
      kInp.addEventListener('input', function () {
        A.kiloManuel = kInp.value;
        var khe = body.querySelector('[data-qz-kilo-hata]'); if (khe) khe.hidden = true;
        if (kInp.value) {
          A.kiloChip = undefined;
          body.querySelectorAll('[data-qz-kilo]').forEach(function (c) { c.classList.remove('is-active'); });
        }
        body.querySelector('[data-qz-kilonext]').disabled = !(A.kiloChip !== undefined || kInp.value);
      });
    }
    if (step === 8) {
      var msg = body.querySelector('[data-qz-calcmsg]');
      setTimeout(function () { if (msg) msg.textContent = tt('qz_taraniyor', 'Uygun mamalar taranıyor…'); }, 500);
      // Katalog geldiğinde (en az 900ms bekleterek) sonuca geç
      var t0 = Date.now();
      loadCatalog().then(function () {
        var kalan = Math.max(0, 900 - (Date.now() - t0));
        setTimeout(function () { if (step === 8) { step = 9; render(); } }, kalan);
      });
    }
  }

  function renderResult() {
    var daily = dailyGrams();
    var gDaily = Math.round(daily / 5) * 5;
    var aylik = Math.round(daily * 30 / 100) / 10;
    var recs = recommend();
    var shown = showAll ? recs : recs.slice(0, 3);

    // Profili bir kez kaydet + cevapları sakla (sonuçlara geri dönülebilsin)
    if (!saved) { saveProfile(); saved = true; }

    var kgNote = A.kilo
      ? String(A.kilo).replace('.', tt('ondalik', ',')) + ' kg'
      : (A.tur === 'kedi' ? tt('qz_ort_kedi', 'ortalama kedi (4 kg)') : tt('qz_ort_kopek', 'ortalama köpek (20 kg)'));
    var yasNote = YAS_AD()[A.yas];

    var h = '<div class="qz__step">' +
      '<span class="qz__done">' + tt('qz_olusturuldu', '✓ Pati Profili oluşturuldu') + '</span>';

    // Birden fazla kedi/köpek profili varsa mini pet seçici
    var many = petList();
    if (many.length > 1) {
      h += '<div class="qz__pets">' + many.map(function (x, i) {
        var act = (x.ad === A.ad && x.tur === A.tur) ? ' is-active' : '';
        return '<button type="button" class="qz__chip' + act + '" data-qz-pet="' + i + '">' +
          (x.tur === 'kedi' ? (IK.cat || '') : (IK.dog || '')) + ' ' + esc(x.ad) + '</button>';
      }).join('') + '</div>';
    }

    h += '<h3 class="qz__rq">' + tt('qz_hazir', '[ad] için önerimiz hazır!', { ad: esc(A.ad) }) + '</h3>' +
      '<div class="qz__portion">' +
      '<div class="qz__portion-nums">' +
      '<div><b>~' + gDaily + ' gr</b><span>' + tt('qz_gunluk', 'günlük porsiyon') + '</span></div>' +
      '<div><b>~' + String(aylik).replace('.', tt('ondalik', ',')) + ' kg</b><span>' + tt('qz_aylik', 'aylık tüketim') + '</span></div>' +
      '</div>' +
      '<p class="qz__portion-note">' + tt('qz_egri', '[kg], [kisir][yas] [tur] eğrisine göre', { kg: kgNote, kisir: A.kisir ? tt('qz_kisir', 'kısır') + ' ' : '', yas: yasNote, tur: A.tur === 'kedi' ? tt('qz_kedi_k', 'kedi') : tt('qz_kopek_k', 'köpek') }) + '</p>' +
      '</div>';

    if (!recs.length) {
      h += '<div class="qz__empty">' + tt('qz_bulamadik', 'Bu kriterlere birebir uyan kuru mama bulamadık.') + '<br>' +
        ((A.alerji || []).length ? tt('qz_genislet', 'Hassasiyet filtresini genişleterek tekrar deneyebilirsin.') : tt('qz_tamamliyoruz', 'Ürün verilerimizi tamamlıyoruz — çok yakında burada öneriler olacak.')) +
        '</div>';
    } else {
      h += '<p class="qz__rtitle">' + tt('qz_sectiklerimiz', '[ad] için seçtiklerimiz', { ad: esc(A.ad) }) + '</p>';
      shown.forEach(function (r, i) {
        var p = r.p, v = r.pick;
        var gunN = v.gun >= 10 ? Math.round(v.gun / 5) * 5 : v.gun;
        var gun = v.gun > 120 ? tt('pp_120_gun', '120+ gün') : tn('pp_yak_gun', gunN, '~[n] gün');
        var tags = [];
        if (boughtBefore(p.u)) tags.push('<span class="qz__tag qz__tag--bought">' + tt('qz_almistin', '✓ Daha önce almıştın') + '</span>');
        if (r.x.tahilsiz) tags.push('<span class="qz__tag qz__tag--ok">' + tt('qz_tahilsiz', 'Tahılsız') + '</span>');
        if (A.yas === 'yavru' && r.x.isYavru) tags.push('<span class="qz__tag">' + tt('qz_yavruya', 'Yavruya özel') + '</span>');
        if (A.yas === 'senior' && r.x.isSenior) tags.push('<span class="qz__tag">' + tt('qz_kidemli_f', 'Kıdemli formülü') + '</span>');
        if (A.kisir && r.x.kisirF) tags.push('<span class="qz__tag">' + tt('qz_kisir_dostu', 'Kısır dostu') + '</span>');
        if (r.preorderOnly) tags.push('<span class="qz__tag qz__tag--po">' + tt('qz_on_siparis', 'Ön sipariş') + '</span>');
        h += '<a class="qz__prod' + (i === 0 && !showAll ? ' qz__prod--top' : '') + '" href="' + esc(p.u) + '?variant=' + v.id + '">' +
          (i === 0 && !showAll ? '<span class="qz__prod-best">' + tt('qz_en_uygun', 'EN UYGUN') + '</span>' : '') +
          '<span class="qz__prod-img">' + (p.img ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" width="58" height="58">' : (IK.paw || '')) + '</span>' +
          '<span class="qz__prod-body">' +
          '<span class="qz__prod-brand">' + esc(p.m) + '</span>' +
          '<span class="qz__prod-name">' + esc(p.t) + '</span>' +
          (tags.length ? '<span class="qz__tags">' + tags.join('') + '</span>' : '') +
          '<span class="qz__prod-pack">' + tt('qz_onerilen_boy', 'Önerilen boy: <b>[kg]</b> — [gun] yeter', { kg: String(v.kg).replace('.', tt('ondalik', ',')) + ' kg', gun: gun }) + '</span>' +
          '<span class="qz__prod-price"><b>' + tl(v.f) + '</b><small>' + tl(Math.round(v.unit)) + '/kg</small></span>' +
          '</span></a>';
      });
      if (!showAll && recs.length > 3) {
        h += '<button type="button" class="qz__all" data-qz-showall>' + tt('qz_tumunu_gor', 'Tüm uygun mamaları gör ([n])', { n: recs.length }) + '</button>';
      }
    }

    h += '<p class="qz__foot">' + tt('qz_kaydedildi', 'Cevapların <strong>Pati Profili</strong>\'ne kaydedildi — maması bitmeden hatırlatacağız. Bu önerilere ve profile, header\'daki pati ikonundan her zaman dönebilirsin.') + '</p>' +
      '<button type="button" class="qz__restart" data-qz-restart>' + tt('qz_bastan', 'Testi baştan yap') + '</button>' +
      '</div>';
    return h;
  }

  /* ---------------- Kayıt ---------------- */
  function saveProfile() {
    var data = {
      ad: A.ad, tur: A.tur, dogum: dogumFromYas(),
      kilo: A.kilo || null, kisir: !!A.kisir, alerji: A.alerji || []
    };
    var ok = false;
    try {
      if (window.PetidiPetProfile && window.PetidiPetProfile.add) {
        ok = !!window.PetidiPetProfile.add(data);
      }
    } catch (e) { ok = false; }
    if (!ok) {
      // Yedek yol: API'ye ulaşılamadıysa profili aynı şemayla doğrudan localStorage'a yaz
      try {
        var p = JSON.parse(localStorage.getItem('petidi_pet_profili')) || null;
        if (!p || !p.petler) p = { v: 1, petler: [] };
        var adKey = String(data.ad).toLowerCase();
        var pet = null;
        p.petler.forEach(function (x) {
          if (x.tur === data.tur && String(x.ad).trim().toLowerCase() === adKey) pet = x;
        });
        if (!pet) {
          pet = { id: 'p' + Date.now().toString(36) + Math.floor(Math.random() * 1e4).toString(36) };
          p.petler.push(pet);
        }
        pet.ad = data.ad; pet.tur = data.tur; pet.irk = pet.irk || '';
        pet.dogum = data.dogum; pet.kilo = data.kilo;
        pet.cinsiyet = pet.cinsiyet || null; pet.kisir = data.kisir; pet.alerji = data.alerji;
        p.v = 1; p.guncelleme = Date.now();
        localStorage.setItem('petidi_pet_profili', JSON.stringify(p));
      } catch (e2) {}
    }
    try { localStorage.setItem(QLS, JSON.stringify({ ts: Date.now(), a: A })); } catch (e3) {}
    // Rozet/çerçeve gibi profile bağlı görünümler tazelensin
    try { document.dispatchEvent(new CustomEvent('petidi:profil')); } catch (e4) {}
  }

  function savedAnswers() {
    try {
      var d = JSON.parse(localStorage.getItem(QLS));
      return (d && d.a && d.a.tur && d.a.ad) ? d.a : null;
    } catch (e) { return null; }
  }

  // Profildeki kedi/köpekler — sonuç ekranındaki pet seçici ve cevap türetme için
  function petList() {
    try {
      var list = (window.PetidiPetProfile && window.PetidiPetProfile.pets()) || [];
      if (!list.length) {
        var p = JSON.parse(localStorage.getItem('petidi_pet_profili'));
        list = (p && p.petler) || [];
      }
      return list.filter(function (x) {
        return x && x.ad && (x.tur === 'kedi' || x.tur === 'kopek');
      });
    } catch (e) { return []; }
  }

  // Bir pet kaydından quiz cevapları türet (yaş çağı doğumdan, bütçe=dengeli)
  function answersFromPet(pet) {
    var yas = 'yetiskin';
    var m = /^(\d{4})(?:-(\d{1,2}))?/.exec(String(pet.dogum || ''));
    if (m) {
      var now = new Date();
      var ay = (now.getFullYear() - +m[1]) * 12 + (now.getMonth() + 1 - (+m[2] || 6));
      if (ay < 12) yas = 'yavru';
      else if (ay >= (pet.tur === 'kedi' ? 120 : 96)) yas = 'senior';
    }
    var kilo = parseFloat(String(pet.kilo == null ? '' : pet.kilo).replace(',', '.'));
    return {
      tur: pet.tur, ad: pet.ad, yas: yas,
      kilo: (kilo && kilo > 0) ? kilo : null,
      kisir: !!pet.kisir, alerji: [].concat(pet.alerji || []),
      butce: 'dengeli'
    };
  }

  // Quiz kaydı yoksa cevapları mevcut Pati Profili'nden türet — "önerilerim"
  // butonu profil formdan oluşturulmuş olsa bile doğrudan sonuç gösterebilsin
  function answersFromProfile() {
    var list = petList();
    return list.length ? answersFromPet(list[0]) : null;
  }

  /* ---------------- Akış ---------------- */
  function go(next, patch) {
    if (patch) for (var k in patch) A[k] = patch[k];
    step = next;
    render();
  }

  function openQuiz() {
    // Pati Profili çekmecesi açıksa kapat (çekmecedeki CTA'dan gelinebilir)
    var petp = document.getElementById('PetProfile');
    if (petp && !petp.hidden) petp.hidden = true;
    root.hidden = false;
    document.body.style.overflow = 'hidden';
    loadCatalog();
    // Daha önce tamamlanmış test ya da mevcut profil varsa doğrudan sonuçlara dön
    if (step === 0) {
      var prev = savedAnswers() || answersFromProfile();
      if (prev) { A = prev; saved = true; showAll = false; step = 8; }
    }
    render();
  }
  function closeQuiz() {
    root.hidden = true;
    document.body.style.overflow = '';
  }
  function restart() {
    A = {}; step = 0; saved = false; showAll = false;
    try { localStorage.removeItem(QLS); } catch (e) {}
    render();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-quiz-open]')) { e.preventDefault(); openQuiz(); return; }
    if (!root.hidden && e.target.closest('[data-qz-close]')) { closeQuiz(); return; }
  });

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-qz-start]')) { go(1); return; }
    if (e.target.closest('[data-qz-restart]')) { restart(); return; }

    // Sonuç ekranında pet değiştirme
    var pc = e.target.closest('[data-qz-pet]');
    if (pc) {
      var lp = petList()[+pc.getAttribute('data-qz-pet')];
      if (lp) { A = answersFromPet(lp); saved = true; showAll = false; render(); }
      return;
    }
    if (e.target.closest('[data-qz-showall]')) { showAll = true; render(); return; }
    if (e.target.closest('[data-qz-back]')) { go(step - 1); return; }

    var o = e.target.closest('[data-qz-opt]');
    if (o) {
      var kv = o.getAttribute('data-qz-opt').split(':');
      o.parentElement.querySelectorAll('.qz__opt').forEach(function (x) { x.classList.remove('is-active'); });
      o.classList.add('is-active');
      // Tek seçimli sorular kısa bir vurgudan sonra otomatik ilerler
      setTimeout(function () {
        if (kv[0] === 'tur') go(2, { tur: kv[1] });
        else if (kv[0] === 'yas') go(4, { yas: kv[1] });
        else if (kv[0] === 'kisir') go(6, { kisirSecim: kv[1], kisir: kv[1] === 'evet' });
        else if (kv[0] === 'butce') go(8, { butce: kv[1] });
      }, 200);
      return;
    }

    if (e.target.closest('[data-qz-ad]')) {
      var inp = body.querySelector('[data-qz-ad-input]');
      if (inp && inp.value.trim()) go(3, { ad: inp.value.trim() });
      return;
    }

    var kc = e.target.closest('[data-qz-kilo]');
    if (kc) {
      A.kiloChip = kc.getAttribute('data-qz-kilo');
      A.kiloManuel = '';
      var ki = document.getElementById('QzKilo'); if (ki) ki.value = '';
      body.querySelectorAll('[data-qz-kilo]').forEach(function (c) { c.classList.toggle('is-active', c === kc); });
      body.querySelector('[data-qz-kilonext]').disabled = false;
      return;
    }
    if (e.target.closest('[data-qz-kilonext]')) {
      var kilo = null;
      // Kilo üst sınırı (3 Kas 2026): gramla yazılanı (1350) geçirme — pet-profile.js kiloHata ile aynı kural
      var kh = kiloHataQz(A.kiloManuel, A.tur);
      var khEl = body.querySelector('[data-qz-kilo-hata]');
      if (khEl) { khEl.textContent = kh; khEl.hidden = !kh; }
      if (kh) { var kiIn = document.getElementById('QzKilo'); if (kiIn) kiIn.focus(); return; }
      if (A.kiloManuel) kilo = Math.round(parseFloat(String(A.kiloManuel).replace(',', '.')) * 10) / 10 || null;
      else if (A.kiloChip) kilo = parseFloat(A.kiloChip);
      go(5, { kilo: kilo });
      return;
    }

    var ac = e.target.closest('[data-qz-alerji]');
    if (ac) {
      A.alerji = A.alerji || [];
      var val = ac.getAttribute('data-qz-alerji');
      var idx = A.alerji.indexOf(val);
      if (idx >= 0) A.alerji.splice(idx, 1); else A.alerji.push(val);
      A.alerjiYok = false;
      render();
      return;
    }
    if (e.target.closest('[data-qz-alerji-yok]')) {
      A.alerji = [];
      A.alerjiYok = !A.alerjiYok;
      render();
      return;
    }
    if (e.target.closest('[data-qz-alerjinext]')) { go(7); return; }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !root.hidden) closeQuiz();
  });

  // Profil değişince (kayıt/silme/düzenleme) çerçeveleri tazele
  document.addEventListener('petidi:profil', scheduleReco);

  // Sonsuz kaydırma / dinamik eklenen kartlar
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      for (var j = 0; j < muts[i].addedNodes.length; j++) {
        var n = muts[i].addedNodes[j];
        if (n.nodeType !== 1) continue;
        if ((n.matches && n.matches('[data-pet-match]')) || (n.querySelector && n.querySelector('[data-pet-match]'))) {
          scheduleReco();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  // Pati Profili ekranı "[ad] için seçtiklerimiz" (3 Kas 2026, Faz 1): testin öneri motoru, cevaplar profilden.
  // Katalog yalnız ilk çağrıda yüklenir; sonuç testteki sıralamanın ilk n'i (stokta önce, uygunluk, kg fiyatı).
  window.PetidiQuiz = {
    oneri: function (pet, n) {
      if (!pet || (pet.tur !== 'kedi' && pet.tur !== 'kopek')) return Promise.resolve([]);
      return loadCatalog().then(function () {
        var eski = A, r = [];
        A = answersFromPet(pet);
        try { r = recommend(); } finally { A = eski; }
        return r.slice(0, n || 3).map(function (o) {
          return { t: o.p.t, m: o.p.m, u: o.p.u + '?variant=' + o.pick.id, img: o.p.img, f: o.pick.f, gun: o.pick.gun, kg: o.pick.kg, alindi: boughtBefore(o.p.u) };
        });
      });
    }
  };
  document.dispatchEvent(new CustomEvent('petidi:quiz-hazir'));

  // ---------- Başlangıç ----------
  renderRecoCards();
})();
